import Icon from '../components/Icon.vue'

Icon.register({
  chess: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M199.8 217.6A6-6 0 0 0 205.8 223.6L205.8 244.4A6-6 0 0 0 199.8 250.4H174C174 282.1 171.9 346.6 191.4 403.6H64.6C84.5 345.5 82 279.2 82 250.4H56.2A6-6 0 0 0 50.2 244.4L50.2 223.6A6-6 0 0 0 56.2 217.6H199.8zM41.6 115.1L76.1 210.2H179.9L214.4 115.1C217.3 107.3 211.5 99 203.2 99H152V68.8H173.6A6-6 0 0 1 179.6 62.8V40.4A6-6 0 0 1 173.6 34.4H145.2V6A6-6 0 0 1 139.2 0H116.8A6-6 0 0 1 110.8 6V34.4H82.4A6-6 0 0 1 76.4 40.4V62.8A6-6 0 0 1 82.4 68.8H104V99H52.8C44.5 99 38.7 107.3 41.6 115.1zM222.7 445.2V417.1A6-6 0 0 1 216.7 411.1H39.3A6-6 0 0 1 33.3 417.1V445.2L11.2 459.3A6-6 0 0 1 8.4 464.4V506A6-6 0 0 1 14.4 512H241.6A6-6 0 0 1 247.6 506V464.4A6-6 0 0 1 244.8 459.3L222.7 445.2zM313.3 300.9L338.1 317.9C338.2 336 338 381.8 326.2 432.4H473.8C462 382 461.8 336.1 461.9 317.9L486.7 300.9A3.9-3.9 0 0 1 488.4 297.8V227.9A3.9-3.9 0 0 1 484.6 224H456.9A3.9-3.9 0 0 1 453 227.9V259.4H430.3V227.9A3.9-3.9 0 0 1 426.5 224H373.5A3.9-3.9 0 0 1 369.7 227.9V259.4H346.9V227.9A3.9-3.9 0 0 1 343.1 224H315.4A3.9-3.9 0 0 1 311.6 227.9V297.8A3.9-3.9 0 0 1 313.3 300.9zM384.8 352.9C384.8 344.5 391.6 337.7 400 337.7S415.2 344.5 415.2 352.9V383.2H384.8V352.9zM504.6 470.1L491 459.4V443.9A3.9-3.9 0 0 1 487.1 440H312.9A3.9-3.9 0 0 1 309.1 443.9V459.4L295.4 470.1A3.9-3.9 0 0 1 293.9 473.1V508.1A3.9-3.9 0 0 1 297.8 512H502.3A3.9-3.9 0 0 1 506.1 508.1V473.1A3.9-3.9 0 0 1 504.6 470.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chess.js
// module id = C2mU
// module chunks = 144